import { render, staticRenderFns } from "./MallOrder.vue?vue&type=template&id=3c6b14f2&scoped=true&"
import script from "./MallOrder.vue?vue&type=script&lang=ts&"
export * from "./MallOrder.vue?vue&type=script&lang=ts&"
import style0 from "./MallOrder.vue?vue&type=style&index=0&id=3c6b14f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6b14f2",
  null
  
)

export default component.exports